export default __webpack_public_path__ + "static/portraits-ac6c769b2738eb9a1c4e37c607e0aaeb.webp";